import { withTranslation } from "react-i18next"
import { Input, Button, notification, Divider, Spin } from "antd"
import { useState } from "react"
import { push } from "connected-react-router";
import { connect } from "react-redux";
import styled from "styled-components";

import { post } from "library/endpoints";
import Text from "components/Text";

import { resetUiEnv } from "modules/ui/actions";

const StyledHoverText = styled(Text)`
  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * PayByGiftCard
 * @param {*} props 
 * @returns 
 */
const PayByGiftCard = (props) => {
  const [code, setCode] = useState(null);
  const [codeInfo, setCodeInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOnCheckCode = async () => {
    try {
      const response = await post(`/frontend/payment/check-gift-code`, {
        code
      })

      setCodeInfo(response.data)
    } catch (error) {
      notification.error({
        message: 'Huho',
        description:
          'Il semblerait que cette carte cadeau soit invalide',
      });
    }
  }

  const calculateAmountToDebit = () => {
    if (props.totalPrice >= codeInfo.remainingValue) {
      // Debit all
      return codeInfo.remainingValue;
    } else {
      // Debit amount of basket
      return props.totalPrice;
    }
  }

  const handleOnDebitGiftCard = async () =>  {
    try {
      setLoading(true)

      let qs = '';
      if (props.promoCodeData) {
        qs += `?code=${props.promoCode}`
      }
    
      const uri = codeInfo.origin === 'ikomiris' ? `/frontend/payment/pay-by-ikomiris-giftcard/${qs}` : `/frontend/payment/pay-by-gift-code/${qs}`

      const response = await post(uri, {
        code,
        basketId: props.basket._id
      });

      setLoading(false)

      if (response.data.paid === true) {
        // Reset basket, redirect to Orders
        props.resetUiEnv();
        props.push('/orders/success')
      } else {
        // Need to complete payment
        console.log('need to complete payment')
        props.setPaymentData(response.data);
      }
      // props.handleRefreshPaymentData();
    } catch (error) {
      setLoading(false)
      notification.error({
        message: 'Huho',
        description:
          'Il semblerait que cette carte cadeau soit invalide',
      });
    }
  }

  return (
    <div style={{ textAlign: 'center', marginTop: 10 }}>
      <Divider />
      {
        loading ? (
          <Spin />
        ) : (
          <>
            {
              !codeInfo && (
                <>
                  <Input.Group compact style={{ textAlign: 'left'}}>
                    <Input style={{ width: 200 }} placeholder="Entrez votre code" onChange={(e) => setCode(e.target.value)}/>
                    <Button type="primary" disabled={!code} onClick={handleOnCheckCode} style={{ marginLeft: 10 }}>Vérifier</Button>
                  </Input.Group>   

                  <Text align="center" style={{ marginTop: 10 }} underline cursor="pointer" onClick={() => props.setDisplayGiftCard(false)}>Annuler</Text> 
                </>
              )
            }

            {
              codeInfo && (
                <div style={{ marginTop: 10 }}>
                  <Text align="center" size="14" style={{ marginBottom: 10 }}>Montant restant sur votre carte : {codeInfo.remainingValue}€</Text>

                  {
                    codeInfo.remainingValue > 0 && (
                      <Button type="primary" onClick={handleOnDebitGiftCard}>Débiter ma carte cadeau de {calculateAmountToDebit()}€ </Button>
                    )
                  }

                  {
                    codeInfo.remainingValue < props.basket.amount && (
                      <Text size={12} align="center" style={{ marginTop: 10 }}>Vous devrez effectuer un règlement complémentaire de {(props.totalPrice - codeInfo.remainingValue).toFixed(2)}€</Text>
                    )
                  }

                  <Divider style={{ margin: 10 }}>ou</Divider>
                  <Button type="link" onClick={() => { setCode(null); setCodeInfo(null)}}>
                    <StyledHoverText size="14" underline color='#53b297'>Utiliser une autre carte cadeau</StyledHoverText>
                  </Button>
                </div>
              )
            }   
          </>
        )
      }
    </div>   
  )
}

const stateToProps = state => ({

})

const dispatchToProps = {
  push,
  resetUiEnv
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(PayByGiftCard))